import constant from "../../constant";

const state = {
  credits: [],
};

const getters = {
  getCredits: (state) => state.credits,
};

const actions = {
  async fetchCredits({ commit }) {
    const response = await this._vm.$api.fetch(
      `${constant.api}sellers_sales_unpaid_totals`
    );
    const data = Array.isArray(response) ? response : response?.data || [];
    commit("setCredits", data);
    return data;
  },
};

const mutations = {
  setCredits(state, data) {
    state.credits = Array.isArray(data) ? data : [];
  },
  resetCredits(state) {
    state.credits = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
